module.exports = __webpack_public_path__ + "static/black-tassel-164f99defd632927f55a77373b50a0ee.png";